"use client";

import { useMessages } from "next-intl";
import { useMemo } from "react";
import { projectText, type ProjectText } from "./projectText";

export type { ProjectText };

/** The tenant-text lookup over this page's catalog; see `projectText`. */
export function useProjectText(): ProjectText {
  const messages = useMessages() as Record<string, unknown>;

  return useMemo(() => projectText(messages), [messages]);
}
